// Kept in sync with backend REQUIREMENT_OPTIONS (lead_service.py).
export const REQUIREMENT_OPTIONS = [
	"Increase School Admissions",
	"School Marketing",
	"Preschool Setup",
	"New School Setup",
	"School Franchise",
	"School Growth & Management",
	"School Branding",
	"Digital Marketing",
	"Other",
];
